<template>
  <div class="bg-sidebar min-h-screen">
    <SideBar class="col-span-2 w-full fixed z-30" />
    <div
      class="min-h-screen w-full transition-[padding] duration-200 ease-in-out"
      :class="sidebar.collapsed ? 'lg:pl-14' : 'lg:pl-65'"
    >
      <div class="lg:py-2 lg:pr-2">
        <div
          class="bg-background lg:rounded-xl lg:border lg:border-border lg:shadow-sm min-h-screen lg:min-h-[calc(100vh-1rem)] overflow-hidden"
        >
          <TopBar class="z-30 hidden w-full lg:block sticky top-0 bg-background" />
          <main class="w-full">
            <!-- pt clears the fixed mobile top bar (h-14 = 56px) plus a gap equal to the
                 horizontal padding, so the first element sits the same distance from the bar
                 as it does from the side edges. -->
            <div class="flex flex-col gap-6 px-4 lg:px-6 pt-18 lg:pt-6 pb-24 overflow-x-hidden">
              <router-view class="block" />
            </div>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/navbars/SideBar'
import TopBar from '@/components/navbars/TopBar'
import { sidebarState } from '@/stores/sidebar'

export default {
  name: 'DashboardView',
  components: {
    SideBar,
    TopBar,
  },
  data() {
    return {
      sidebar: sidebarState,
    }
  },
}
</script>
<style></style>
